import React from "react";
import { Navigate } from "react-router-dom";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { Box, Button, CircularProgress } from "@mui/material";
import { useReportsContext } from "../hooks/useReportsContext";
import { ReportsList } from "./ReportsList";
import { ReportView } from "./ReportView";
import ReportsMessage from "./ReportsMessage";

//This component is responsible for displaying the reports content.
export const ReportsLanding: React.FC = () => {
  const { reportsList, isLoading, selectedReport, reportGenerationData, fetchReportGenerationData, setSelectedReport } = useReportsContext();
  const { error } = useErrorContext();


  if (error) {
    return (
      <Navigate to="/error" />
    );
  }
    
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 1, color:"primary.dark" }}>
        <CircularProgress disableShrink size={25} />
      </Box>
    );
  }

  if (!reportsList?.List || reportsList?.List.length === 0) {
    return (
      <ReportsMessage message="No reports to display." />
    );
  }

  if (selectedReport && reportGenerationData) {
    return (
      <Box sx={{ padding: 1 }}>
        <Button variant="contained" size="medium" color="primary" onClick={() => setSelectedReport(null)} sx={{ ml: 10, mb: 2 }}>Back</Button>
        <ReportView reportData={reportGenerationData} />
      </Box>
    );
  }

  return (
    <ReportsList reports={reportsList?.List ?? []} onView={(report) => { if (typeof report.ReportKey === "string" && report.ReportKey) { fetchReportGenerationData(report.ReportKey, report); }}} />
  );
};
